import React from 'react'
import './styles.css'
import {Spinner } from 'react-bootstrap';
const Spinners = () => {

    return (
        <>
            <div className="overlay">
                <div className='spinner'>
                    <Spinner animation="border" role="status"/>
                </div>
            </div>
        </>
    )
}

export default Spinners